{
    "PlaysoundLabel": "Lire le son (nécessite le lecteur multimédia local) :",
    "ActivewindowLabel": "Fenêtre active (navigateur à onglet unique IE\/Firefox uniquement) :",
    "AlarmActions_SectionHeader": "Actions d'alarme",
    "AlarmActions_SectionPara": "Lorsque les alarmes sont activées, la ligne du rapport et\/ou les statistiques correspondantes clignotent. Vous pouvez choisir ci-dessous des actions supplémentaires qui se produisent pour le rapport actuellement actif lorsque l'une de ses alarmes commence à être déclenchée.",
    "NAME": "AlarmActions"
}